import React from 'react'
import { default as MuiCheckbox } from '@material-ui/core/Checkbox'
import type { CheckboxProps as MuiCheckboxProps } from '@material-ui/core/Checkbox'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '../../styles'

// Primary = light gray when unchecked, dark gray when checked
// Secondary = dark gray when unchecked, white when checked
const useStyles = makeStyles<Theme, MuiCheckboxProps>((theme) => {
  const { pxToRem } = theme.typography

  const primaryColors = {
    checked: theme.paintscout.palette.brand.Neutral.P50,
    unchecked: theme.paintscout.palette.brand.Neutral.P85,
    disabled: theme.paintscout.palette.brand.Neutral.P94
  }

  const secondaryColors = {
    checked: theme.palette.common.white,
    unchecked: theme.paintscout.palette.brand.Neutral.P80,
    disabled: theme.paintscout.palette.brand.Neutral.P50
  }

  return {
    root: {},
    checked: {},
    disabled: {},
    colorPrimary: {
      color: primaryColors.checked,
      '&$checked': {
        color: primaryColors.checked
      },
      '& $uncheckedIcon': {
        background: primaryColors.unchecked
      },
      '&$disabled $uncheckedIcon': {
        background: primaryColors.disabled
      },
      '&$disabled': {
        color: primaryColors.disabled
      }
    },
    colorSecondary: {
      color: secondaryColors.checked,
      '&$checked': {
        color: secondaryColors.checked
      },
      '& $uncheckedIcon': {
        background: secondaryColors.unchecked
      },
      '&$disabled $uncheckedIcon': {
        background: secondaryColors.disabled
      },
      '&$disabled': {
        color: secondaryColors.disabled
      }
    },
    uncheckedIcon: {
      width: pxToRem(18),
      height: pxToRem(18),
      margin: pxToRem(3),
      borderRadius: pxToRem(2)
    }
  }
})

export interface CheckboxProps extends MuiCheckboxProps {
  classes?: MuiCheckboxProps['classes'] & StyleClasses<typeof useStyles>
  /**
   * Icon to show when unchecked
   */
  icon?: React.ReactNode
  /**
   * Icon to show when checked
   */
  checkedIcon?: React.ReactNode
}

function Checkbox(props: CheckboxProps) {
  const classes = useStyles(props)
  const { uncheckedIcon: _uncheckedIcon, ...muiClasses } = classes

  return <MuiCheckbox color="primary" {...props} classes={muiClasses} icon={props.icon ?? UncheckedIcon(props)} />
}

const UncheckedIcon = ({ ...props }) => {
  const classes = useStyles(props)

  return (
    <div>
      <div className={classes.uncheckedIcon} />
    </div>
  )
}

export default Checkbox
